import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

const Modal = ({ isOpen, onClose, message, primaryAction, primaryButtonText, secondaryAction, secondaryButtonText }) => {
  if (!isOpen) return null;

  // Usar createPortal para montar el modal directamente en el body
  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <div className="modal-buttons">
          {secondaryAction && secondaryButtonText && (
            <button onClick={secondaryAction} className="modal-button secondary-button">
              {secondaryButtonText}
            </button>
          )}
          {primaryAction && primaryButtonText ? (
            <button onClick={primaryAction} className="modal-button">
              {primaryButtonText}
            </button>
          ) : (
            <button onClick={onClose} className="modal-button">
              Aceptar
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body // Montamos el modal directamente en el body para que cubra toda la página
  );
};

export default Modal; 